import React, { ReactNode } from "react";
import Icon from "@tvg/atomic-ui/_static/Icons";
import { arrowRight } from "@tvg/atomic-ui/_static/Icons/icons";
import { buildColor } from "@tvg/design-system";
import {
  RowContainer,
  ClickableArea,
  IconContainer
} from "./styled-components";

interface Props {
  children: ReactNode;
  qaLabel?: string;
  onClick?: (event: React.MouseEvent<HTMLDivElement>) => void;
}

const ClickableRow = ({ children, qaLabel = "row-item", onClick }: Props) => (
  <RowContainer data-qa-label={`${qaLabel}`}>
    <ClickableArea onClick={onClick}>{children}</ClickableArea>
    <IconContainer>
      <Icon
        icon={arrowRight}
        size={16}
        color={buildColor("grey", "800")}
        qaLabel="clickableRow-arrow-icon"
      />
    </IconContainer>
  </RowContainer>
);

export default ClickableRow;
